import {
    StyledApplyButton,
    StyledCancelButton,
    StyledFooterRow,
} from './styles';

interface RangeCalendarFooterProps {
    onCancel: () => void;
    onApply: () => void;
}

export const RangeCalendarFooter = ({
    onCancel,
    onApply,
}: RangeCalendarFooterProps) => (
    <StyledFooterRow>
        <StyledCancelButton
            size="large"
            onClick={onCancel}
            className="!btn-secondary"
        >
            Cancel
        </StyledCancelButton>
        <StyledApplyButton
            size="large"
            onClick={onApply}
            className="!btn-primary w-60"
        >
            Apply
        </StyledApplyButton>
    </StyledFooterRow>
);
